import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';

export function setAguardando(aguardando) {
    return {
        type: 'DRE_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function setFiltro(filtro) {
    return {
        type: 'DRE_SET_FILTRO',
        payload: filtro
    };
}

export function getListaDRE() {
	return async (dispatch, getState) => {

        setAguardando(true);

        const filtro = getState().dre.filtro;

        let listaReceita = [];

        await axios.get(`${consts.API_URL}/receita/dre?padrao=true
            &data_inicial=${getState().dre.filtro.data_inicial}
            &data_final=${getState().dre.filtro.data_final}
            ${(filtro.ids_empresa || []).length ? `&ids_empresa=${filtro.ids_empresa.join(',')}` : ''}
            ${(filtro.ids_centro_custo || []).length ? `&ids_centro_custo=${filtro.ids_centro_custo.join(',')}` : ''}
            ${(filtro.ids_analitica || []).length ? `&ids_analitica=${filtro.ids_analitica.join(',')}` : ''}
            ${(filtro.ids_forma_pagamento || []).length ? `&ids_forma_pagamento=${filtro.ids_forma_pagamento.join(',')}` : ''}
            ${(filtro.ids_destinatario || []).length ? `&ids_destinatario=${filtro.ids_destinatario.join(',')}` : ''}
        `).then(result => {
			dispatch({
				type: 'DRE_RECEITA_LISTADO',
				payload: result
			});

            listaReceita = result.data;

		}).catch(ex => {
			setErroAPI(ex);
		});

        let listaDespesa = [];

		await axios.get(`${consts.API_URL}/despesa/dre?padrao=true
            &data_inicial=${getState().dre.filtro.data_inicial}
            &data_final=${getState().dre.filtro.data_final}
            ${(filtro.ids_empresa || []).length ? `&ids_empresa=${filtro.ids_empresa.join(',')}` : ''}
            ${(filtro.ids_centro_custo || []).length ? `&ids_centro_custo=${filtro.ids_centro_custo.join(',')}` : ''}
            ${(filtro.ids_fornecedor || []).length ? `&ids_fornecedor=${filtro.ids_fornecedor.join(',')}` : ''}
            ${(filtro.ids_analitica || []).length ? `&ids_analitica=${filtro.ids_analitica.join(',')}` : ''}
            ${(filtro.ids_forma_pagamento || []).length ? `&ids_forma_pagamento=${filtro.ids_forma_pagamento.join(',')}` : ''}
            ${(filtro.ids_destinatario || []).length ? `&ids_origem=${filtro.ids_destinatario.join(',')}` : ''}
        `).then(result => {
			dispatch({
				type: 'DRE_DESPESA_LISTADO',
				payload: result
			});

            listaDespesa = result.data;

		}).catch(ex => {
			setErroAPI(ex);
		});        

        //COMPETÊNCIAS

        let listaCompetencias = [];

        listaReceita.forEach(item => {
            if (!listaCompetencias.includes(item.competencia)) {
                listaCompetencias.push(item.competencia);
            }
        });
        listaDespesa.forEach(item => {
            if (!listaCompetencias.includes(item.competencia)) {
                listaCompetencias.push(item.competencia);
            }
        });

        dispatch({
            type: 'DRE_COMPETENCIA_LISTADO',
            payload: {
                data: listaCompetencias
            }
        });

        //GRUPOS

        let listaGrupos = [];

        listaReceita.forEach(item => {
            if (!listaGrupos.filter(grupo => grupo.id == item.id_grupo).length) {
                listaGrupos.push({ id: item.id_grupo, nome: item.nome_grupo, tipo: 'receita' });
            }
        });
        listaDespesa.forEach(item => {
            if (!listaGrupos.filter(grupo => grupo.id == item.id_grupo).length) {
                listaGrupos.push({ id: item.id_grupo, nome: item.nome_grupo, tipo: 'despesa' });
            }
        });

        dispatch({
            type: 'DRE_GRUPO_LISTADO',
            payload: {
                data: listaGrupos
            }
        });

        setAguardando(false);
	};
}